export default __webpack_public_path__ + "static/media/worry-free-icon.26c19a0c.svg";